document.addEventListener('DOMContentLoaded', () => {
  const coachesGridContainer = document.getElementById('coachesGridContainer');
  if (!coachesGridContainer) {
    return;
  }

  const saveCoachRosterBtn = document.getElementById('saveCoachRosterBtn');
  const coachRosterForm = document.getElementById('coachRosterForm');
  const seasonSelect = document.getElementById('seasonSelect');

  if (seasonSelect) {
    if (window.jQuery && window.jQuery.fn.select2) {
      setTimeout(() => {
        const $select = window.jQuery(seasonSelect);
        $select.off('change').on('change', function(e) {
          handleSeasonChange(e);
        });
      }, 500);
    } else {
      seasonSelect.addEventListener('change', handleSeasonChange);
    }
  }

  if (saveCoachRosterBtn && coachRosterForm) {
    const defaultButtonContent = saveCoachRosterBtn.dataset.defaultText || saveCoachRosterBtn.textContent;
    const loadingButtonText = saveCoachRosterBtn.dataset.loadingText || 'Saving...';
    const errorMessage = saveCoachRosterBtn.dataset.errorText || 'Error updating coach roster';

    saveCoachRosterBtn.addEventListener('click', () => {
      saveCoachRosterBtn.disabled = true;
      saveCoachRosterBtn.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${loadingButtonText}`;

      const formData = new FormData(coachRosterForm);
      const csrfMeta = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : null;

      const headers = {
        'X-Requested-With': 'XMLHttpRequest'
      };

      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken;
      }

      const request = fetch(coachRosterForm.action, {
        method: 'POST',
        body: formData,
        headers
      });

      // This is fetch (not axios), so the global axios interceptor does NOT fire.
      // handleJsonResponse displays the server-rendered success/error message itself.
      window.TeamforceNotifications.handleJsonResponse(request, {
        onSuccess: () => {
          if (window.jQuery && typeof window.jQuery('#coachRosterModal').modal === 'function') {
            window.jQuery('#coachRosterModal').modal('hide');
          }
          window.location.reload();
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error:', error);
        window.showNotification(errorMessage, 'error');
      }).finally(() => {
        saveCoachRosterBtn.disabled = false;
        saveCoachRosterBtn.innerHTML = defaultButtonContent;
      });
    });
  }
});

function handleSeasonChange(e) {
  const container = document.getElementById('coachesGridContainer');
  if (!container) return;

  const loadingStartTime = Date.now();
  showLoadingOverlay(container);

  const seasonValue = e.target ? e.target.value : e.val;

  const url = new URL(window.location.href);
  url.searchParams.set('season_id', seasonValue);

  fetch(url.toString(), {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'text/javascript'
    }
  })
    .then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then((html) => {
      container.innerHTML = html;
      window.history.pushState({}, '', url);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error loading coaches:', error);
      const msg = (container.dataset && container.dataset.errorText) || 'Error loading coaches. Please try again.';
      window.showNotification(msg, 'error');
    })
    .finally(() => {
      const loadingDuration = Date.now() - loadingStartTime;
      const minDisplayTime = 300;
      const remainingTime = Math.max(0, minDisplayTime - loadingDuration);

      setTimeout(() => {
        hideLoadingOverlay(container);
      }, remainingTime);
    });
}

function showLoadingOverlay(container) {
  const overlay = document.createElement('div');
  overlay.className = 'loading-overlay';
  overlay.innerHTML = `
    <div class="text-center">
      <div class="spinner-border" role="status" style="width: 3rem; height: 3rem; border-width: 0.3rem;">
        <span class="sr-only">Loading...</span>
      </div>
      <div style="margin-top: 1rem; font-size: 1.2rem; font-weight: bold; color: var(--main-color, #007bff);">
        Loading...
      </div>
    </div>
  `;
  container.style.position = 'relative';
  container.appendChild(overlay);
}

function hideLoadingOverlay(container) {
  const overlay = container.querySelector('.loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}
